import React from "react";
import { useParams } from "react-router-dom";
import { useGetProductBySlugQuery } from "../../api/productApi";
import ProductShowcase from "./ProductShowcase";
import ProductDescriptions from "./ProductDescriptions";
import RelatedProducts from "./RelatedProducts";

const SingleProductContainer: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const {
    data: product,
    isLoading,
    isFetching,
    error,
  } = useGetProductBySlugQuery(slug || "");

  return (
    <>
      <ProductShowcase
        product={product}
        isLoading={isLoading || (isFetching && !product)}
        error={error}
      />
      <ProductDescriptions
        product={product}
        isLoading={isLoading || (isFetching && !product)}
      />
      {/* Only render RelatedProducts when product data is available and has categories */}
      {product && product.categories && product.categories.length > 0 && (
        <RelatedProducts currentProduct={product} />
      )}
    </>
  );
};

export default SingleProductContainer;
